import { createBrowserRouter } from "react-router-dom";

import { RootLayout } from "./routes/RootLayout";
import { HomePage } from "./routes/HomePage";
import { FeatureFlagsPage } from "./routes/FeatureFlagsPage";
import { MaintenancePage } from "./routes/MaintenancePage";
import { NotFoundPage } from "./routes/NotFoundPage";
import { RequireAuth } from "./routes/RequireAuth";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <RootLayout />,
    children: [
      {
        element: <RequireAuth />,
        children: [
          { index: true, element: <HomePage /> },
          { path: "feature-flags", element: <FeatureFlagsPage /> },
          { path: "maintenance", element: <MaintenancePage /> },
        ],
      },
      { path: "*", element: <NotFoundPage /> },
    ],
  },
]);
